<template>
  <div>
    <div>
      <CCard>
        <CTabs :activeTab.sync="activeTab">
          <CTab :title="$t('role.products.settings.general.tab')">
            <div class="d-flex justify-content-center" v-if="loading">
              <CSpinner color="info" />
            </div>

            <form action="" @submit.prevent="onSubmit" v-if="marketData">
              <CRow class="align-items-center mb-2">
                <CCol md="4">
                  <strong>{{
                    $t("role.products.settings.general.autoPrice.title")
                  }}</strong>
                  <p>
                    {{
                      $t("role.products.settings.general.autoPrice.description")
                    }}
                  </p>
                </CCol>
                <CCol md="2">
                  <CSwitch
                    variant="3d"
                    size="sm"
                    color="secondary"
                    :checked.sync="marketData.auto_price"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol md="3">
                  <CInput
                    v-if="marketData.auto_price"
                    v-model="marketData.d_margin"
                    :disabled="!marketData.auto_price"
                    append="%"
                    type="number"
                    step="0.1"
                    min="0"
                    custom
                  >
                    <template #label>
                      <label>
                        <strong>{{
                          $t("role.products.settings.general.autoPrice.markup")
                        }}</strong>
                        <em class="text-danger">*</em>
                      </label>
                    </template>
                  </CInput>
                </CCol>
              </CRow>

              <vue-ladda
                :loading="saving"
                data-style="zoom-in"
                button-class="btn btn-primary mt-3"
                type="submit"
              >
                {{
                  $t("role.products.settings.general.autoPrice.submitButton")
                }}
              </vue-ladda>
            </form>
          </CTab>
          <CTab :title="$t('role.products.settings.producers.tab')">
            <SettingsProducer v-if="activeTab == 1" />
          </CTab>
        </CTabs>
      </CCard>
    </div>
  </div>
</template>

<script>
import SettingsProducer from "./SettingsProducer";
import { apiGet, apiPatch } from "../../../helpers/apiHelper";

export default {
  name: "ProfileData",
  data() {
    return {
      activeTab: 0,
      loading: true,
      saving: false,
      marketData: null,
    };
  },
  async created() {
    await this.getMarket();
  },
  methods: {
    async getMarket() {
      this.loading = true;

      const response = await apiGet(
        "role_market",
        [this.$store.state.role.id],
        this.$store.state.role.market__id
      );
      if (response && response.status === 200) {
        this.loading = false;
        this.marketData = response.data;
      } else {
        this.loading = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading pricing data",
          color: "danger",
          autohide: true,
        });
      }
    },

    async onSubmit() {
      const roleId = this.$store.state.role.id;
      const requestParams = {
        id: this.marketData.id,
        auto_price: this.marketData.auto_price,
        d_margin: this.marketData.d_margin,
      };

      this.saving = true;
      console.log(requestParams);

      const response = await apiPatch(
        "role_market",
        requestParams.id,
        requestParams,
        [this.$store.state.role.id]
      );

      if (response && response.status === 200) {
        this.saving = false;
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.finance.invoicesSettings.success"),
          color: "success",
          autohide: true,
        });
      } else {
        this.saving = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("common.editor.messages.ko.title"),
          text: this.$t("role.finance.invoicesSettings.failed"),
          color: "info",
          autohide: true,
        });
      }
    },
  },
  components: {
    SettingsProducer,
  },
};
</script>
